import { render, staticRenderFns } from "./a10.vue?vue&type=template&id=5e4382c8&scoped=true"
import script from "./a10.vue?vue&type=script&lang=js"
export * from "./a10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4382c8",
  null
  
)

export default component.exports